(function(angular){
	'use strict';
	
	angular
		.module('opportunityFundModule')
		.controller('OpportunityFundController', [
			'globalConfig',
			'ReitElementFactory',
			OpportunityFundFunction
		]);
	
	function OpportunityFundFunction(
		globalConfig,
		ReitElementFactory
	){
		var opportunityFund = this;

		opportunityFund.$onInit = function() {
			angular.extend(opportunityFund, globalConfig);

			ReitElementFactory
				.getReitElementsForReit(opportunityFund.oFundReitId, ['flatReitElementList'])
				.then(function(formattedLists) {
					opportunityFund.featuredProperties = formattedLists.flatReitElementList;
				});
		};
	}
})(window.angular);